import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
//import { withRouter } from 'react-router-dom';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
// Material components
import styles from './../../../style';
import validate from 'validate.js';
import schema from './schema';
import MessageBox from 'util/messageBox';
import { GlobalSearch } from 'views/Common/components/';

import {
  Card,
  CardContent,
  Grid,
  Button,
  TextField,
  Typography,
  CircularProgress,
  MenuItem,
  Select,
  InputLabel,
  FormControl
} from '@material-ui/core';

import { connect } from 'react-redux';

import {
  addPatient,
  getPatients,
  getSearchPatients
} from 'services/patient/action';
import { Roles } from 'util/enum';

const Create = props => {
  const { classes, className, ehrID, patName, ...rest } = props;

  const initialUserState = {
    firstname: '',
    middleinitial: '',
    lastname: '',
    roles: Roles.user + '+' + Roles.patient,
    mobilenumber: '',
    emailaddress: '',
    confirmEmail: '',
    selectedPatient: null,
    isValid: false,
    touched: {},
    errors: {},
    isLoading: false,
    page: 0,
    limit: 20,
    order: 'ASC',
    sortBy: 'lastname',
    search: ''
  };
  const [succMsg, setSuccMsg] = useState(false);
  const [values, setValues] = useState(initialUserState);
  const [search, setSearch] = useState(null);
  const [showSearch, setShowSearch] = useState(false);
  const [data, setData] = useState(null);
  const [patients, setPatients] = useState([]);
  const [country, setCountry] = React.useState('US');
  const [phoneError, setPhoneError] = React.useState('');

  const phoneRegex = {
    US: /^(\+?1)?[2-9]\d{2}[2-9]\d{6}$/,
    CA: /^(\+?1)?[2-9]\d{2}[2-9]\d{6}$/,
    IN: /^(\+?91)?[6-9]\d{9}$/
  };

  const validatePhone = (phoneNumber, countryCode) => {
    const cleaned = phoneNumber.replace(/[\s\-\(\)]/g, '');

    if (!cleaned) {
      setPhoneError('Mobile number is required');
      return false;
    }

    if (!phoneRegex[countryCode].test(cleaned)) {
      setPhoneError(`Invalid ${countryCode} phone number format`);
      return false;
    }

    setPhoneError('');
    return true;
  };

  const handlePhoneChange = (event) => {
    const value = event.target.value;
    handleChange('mobilenumber', value);
    validatePhone(value, country);
  };

  const handleCountryChange = (event) => {
    const newCountry = event.target.value;
    setCountry(newCountry);
    if (values.mobilenumber) {
      validatePhone(values.mobilenumber, newCountry);
    }
  };

  useEffect(() => {
    if (search) {
      if (props.patients !== undefined) {
        setData(props.patients);
        if (data && data.length > 0) {
          setShowSearch(true);
        } else {
          setShowSearch(false);
        }
      }
    }
  }, [props.patients]);

  const hasError = field =>
    values.touched[field] && values.errors[field] ? true : false;

  const handleChange = (field, value) => {
    const newState = { ...values };
    newState[field] = value;
    newState.touched[field] = true;
    if (field == 'lastname') {
      setSearch(value);
      if (value && value.length > 0) {
        setShowSearch(true);
      } else {
        setData(null);
        setShowSearch(false);
      }
    }
    const errors = validate(newState, schema);
    newState.errors = errors || {};
    newState.isValid = errors ? false : true;
    setValues(newState);
  };

  const handleSubmit = async () => {
    if (values.isValid) {
      const newState = { ...values };
      const patientId = newState.selectedPatient
        ? newState.selectedPatient.id
        : 0;
      setValues({ ...values, isLoading: true });
      newState.mobilenumber = country === 'IN' ? '+91' + newState.mobilenumber : '+1' + newState.mobilenumber;
      const status = await props.addPatient(ehrID, patientId, newState);
      if (status) {
        setSuccMsg(true);
        setValues(initialUserState);
        const patients = props
          .getPatients(ehrID, values.page, values.search, values.limit)
          .then(patientsStatus => {
            if (patientsStatus) {
              setPatients(patients);
            }
          });
      } else {
        setValues({ ...values, isLoading: false });
      }
    }
  };

  const handleCloseAll = () => {
    setSuccMsg(false);
  };

  const computeAge = dob => {
    var magicNumber = 1000 * 60 * 60 * 24 * 365;
    var age = Math.abs(new Date() - new Date(dob));
    age = Math.floor(age / magicNumber);

    return age;
  };

  function splitCountryAndNumber(raw) {
    const digits = raw.toString().replace(/\D/g, ''); // keep only 0–9

    if (digits.startsWith('91')) {
      return {
        countryCode: '91',           // India
        number: digits.slice(2)      // rest after 91
      };
    }

    if (digits.startsWith('1')) {
      return {
        countryCode: '1',            // US/Canada (NANP)
        number: digits.slice(1)      // rest after 1
      };
    }

    return {
      countryCode: null,
      number: digits
    };
  }

  const prefillPatient = patient => {
    const newState = { ...values };
    newState.lastname = patient.lastname;
    newState.firstname = patient.firstname;
    newState.mobilenumber = patient?.credentials?.mobilenumber && splitCountryAndNumber(patient?.credentials?.mobilenumber)?.number || '';
    let country = patient?.credentials?.mobilenumber && splitCountryAndNumber(patient?.credentials?.mobilenumber)?.countryCode || '';
    newState.emailaddress = patient.emailaddress || '';
    newState.confirmEmail = patient.emailaddress || '';
    newState.selectedPatient = patient;
    setValues(newState);
    setCountry(country == "+91" ? "IN" : "US")
    setShowSearch(false);
  };

  return (
    <Card
      {...rest}
      className={clsx(classes.cardRoot, className)}
      style={{ borderTopLeftRadius: 0 }}>
      <Grid container>
        <Grid item xs={12} className={classes.cardHeader}>
          <Typography variant="h2">Add</Typography>
        </Grid>
        <Grid item xs={12} className={classes.cardSubHeader}>
          <Typography variant="h3">Patient Information</Typography>
        </Grid>
      </Grid>
      <CardContent>
        <Grid container spacing={3}>
          <Grid item xs={12} style={{ position: 'relative' }}>
            <TextField
              InputLabelProps={{
                classes: {
                  focused: classes.labelFocused
                }
              }}
              autoComplete="off"
              error={hasError('lastname')}
              fullWidth
              helperText={
                hasError('lastname') ? values.errors.lastname[0] : null
              }
              label="Last Name"
              name="lastname"
              required
              variant="outlined"
              color="Primary"
              onChange={event =>
                handleChange('lastname', event.target.value)
              }
              value={values.lastname}
            />
            {showSearch ? (
              <GlobalSearch
                isGlobal={false}
                searchterm={search}
                globalsearchList={data}
                open={showSearch}
                setShowSearch={setShowSearch}
                prefillPatient={prefillPatient}
              />
            ) : (
              ''
            )}
          </Grid>

          <Grid item xs={12}>
            <TextField
              InputLabelProps={{
                classes: {
                  focused: classes.labelFocused
                }
              }}
              error={hasError('firstname')}
              fullWidth
              helperText={
                hasError('firstname') ? values.errors.firstname[0] : null
              }
              label="First Name"
              name="firstname"
              required
              variant="outlined"
              color="Primary"
              onChange={event => handleChange('firstname', event.target.value)}
              value={values.firstname}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <FormControl variant="outlined" fullWidth>
              <InputLabel>Country</InputLabel>
              <Select
                value={country}
                onChange={handleCountryChange}
                label="Country"
              >
                <MenuItem value="US">+1</MenuItem>
                <MenuItem value="IN">+91</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={9}>
            <TextField
              InputLabelProps={{
                shrink: true,
                classes: {
                  focused: classes.labelFocused
                }
              }}
              error={hasError('mobilenumber') || !!phoneError}
              fullWidth
              helperText={
                hasError('mobilenumber')
                  ? values.errors.mobilenumber[0]
                  : phoneError
              }
              label="Mobile Number"
              name="mobilenumber"
              required
              variant="outlined"
              color="Primary"
              onChange={handlePhoneChange}
              value={values.mobilenumber}
              inputProps={{
                maxLength: 10  // Limits input to 10 characters
              }}
              placeholder={country === 'IN' ? '98765 43210' : '(555) 123-4567'}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              InputLabelProps={{
                shrink: true,
                classes: {
                  focused: classes.labelFocused
                }
              }}
              error={hasError('emailaddress')}
              fullWidth
              helperText={
                hasError('emailaddress') ? values.errors.emailaddress[0] : null
              }
              label="Email Address"
              name="emailaddress"
              required
              variant="outlined"
              color="Primary"
              onChange={event =>
                handleChange('emailaddress', event.target.value)
              }
              value={values.emailaddress}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              InputLabelProps={{
                shrink: true,
                classes: {
                  focused: classes.labelFocused
                }
              }}
              error={hasError('confirmEmail')}
              fullWidth
              helperText={
                hasError('confirmEmail') ? values.errors.confirmEmail[0] : null
              }
              label="Confirm Email Address"
              name="confirmEmail"
              required
              variant="outlined"
              color="Primary"
              onChange={event =>
                handleChange('confirmEmail', event.target.value)
              }
              value={values.confirmEmail}
            />
          </Grid>
          <Grid item xs={12} style={{ textAlign: 'right' }}>
            <Button
              variant="contained"
              color="primary"
              disabled={!values.isValid || phoneError || values?.isLoading}
              onClick={handleSubmit}>
              {values?.isLoading && <CircularProgress size={20} style={{marginRight: 5}} color="inherit" /> }
               Send Invite
            </Button>

          </Grid>
        </Grid>
        <MessageBox
          open={succMsg}
          variant="success"
          onClose={handleCloseAll}
          message="Account activation mail sent successfully"
        />
      </CardContent>
    </Card>
  );
};

Create.propTypes = {
  className: PropTypes.string
};

const mapDispatchToProps = {
  addPatient,
  getPatients,
  getSearchPatients
  //computeAge
};

const mapStateToProps = state => ({
  ehrID: state.profile && state.profile.ehrID,
  patName: state.search,
  patients: state.patient && state.patient.search && state.patient.search.result
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Create))
);
